import { Component, ElementRef } from '@angular/core';
import { WcagService } from './wcag.service';

@Component({
  selector: 'wcag-component',
  templateUrl: './wcag.component.html',
})
export class WcagComponent {

  constructor(
    public elementRef: ElementRef,
    public wcagService: WcagService
  ) {
    this.wcagService.elementRef = elementRef;
  }
}
